export const LIMIT = 20;
const config = {
    healthz() {
        return {
            url: "/__health"
        };
    },
    upload(type, file) {
        return {
            method: 'POST',
            url: `/v1/upload/${type}`,
            headers: {
                'Content-Type': file.type,
            },
            data: file,
            options: {
                credentials: 'include'
            }
        };
    },
    currencies() {
        return {
            url: '/v1/currencies',
            // cache: true,
            // ttl: 300000,
        };
    },
    buildings(path, { limit = LIMIT, ...params } = {}) {
        return {
            url: "/v1/map/list",
            params: {
                path,
                limit,
                ...params
            }
        };
    },
    count(path, params = {}) {
        return {
            url: "/v1/map/count",
            params: {
                path,
                ...params
            }
        };
    },
    labels(path, params = {}) {
        return {
            url: "/v1/map/labels",
            params: {
                path,
                ...params
            }
        };
    },
    listings(path, { limit = LIMIT, page = 1, ...params } = {}) {
        return {
            url: "/v1/map",
            params: {
                path,
                limit,
                skip: Math.max(0, page - 1) * LIMIT,
                ...params
            }
        };
    },
    listing(path, { id, lat, lng, ...params }) {
        return {
            url: "/v1/map/list",
            params: {
                path,
                limit: 1,
                skip: 0,
                filter: { id },
                lat,
                lng,
                ...params
            }
        };
    },
    detail(path, id) {
        return {
            url: "/v1/property/" + id,
            params: { path }
        };
    },
    me() {
        return {
            url: '/v1/me',
            options: {
                credentials: 'include'
            }
        };
    },
    refresh(organizationId, appId) {
        return {
            url: '/v1/refresh',
            method: 'GET',
            params: {
                appId,
                organizationId,
            },
            options: {
                credentials: 'include'
            }
        };
    },
    fields(type, buildingType) {
        return {
            url: "/v1/fields",
            params: { type, buildingType }
        };
    },
    videos() {
        return {
            url: '/v1/videos',
            headers: {
                referer: 'https://en.openrm.jp'
            },
            // cache: true,
            // ttl: 300000,
        };
    },
    neighborhood(coords) {
        return {
            url: '/v1/neighborhood',
            params: { point: coords },
        };
    },
    estimates(params) {
        return {
            url: '/v1/estimates',
            params,
        };
    },
    meta(path) {
        return {
            method: 'GET',
            url: '/v1/page/meta',
            params: { path },
        };
    },
    agent(id, organizationId) {
        return {
            method: 'GET',
            url: `/v1/agents/${organizationId}/${id}/profiles`
        };
    },
    agentProperties(id, organizationId, skip) {
        return {
            url: `/v2/agents/${organizationId}/${id}/list`,
            params: { limit: 20, skip },
        };
    },
    visitorToken(userId, documentId) {
        return {
            url: '/v1/inquiry/token',
            method: 'POST',
            data: { userId, documentId },
        };
    },
    inquiry(token, form) {
        return {
            url: '/v1/inquiry',
            method: 'POST',
            data: form,
            headers: {
                authorization: `Bearer ${token}`,
            },
        };
    },
    contact(data) {
        return {
            method: 'POST',
            url: '/v1/contact',
            data,
            options: {
                credentials: 'include'
            }
        };
    },
    updateProfile(data) {
        return {
            url: '/v1/profile',
            method: 'POST',
            data,
            options: {
                credentials: 'include'
            }
        };
    },
};
export default config;
